"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Direction;
(function (Direction) {
    /**
     * Single row layout or horizontal layout or stacked along side each other.
     */
    Direction["Row"] = "row";
    /**
     * Single column layout or vertical layout or stacked on top of each other.
     */
    Direction["Column"] = "column";
})(Direction = exports.Direction || (exports.Direction = {}));
/**
 * Container component for option group components.  Establishes direction of options.
 */
exports.OptionsGroupContainer = function (props) {
    var _a = props.direction, direction = _a === void 0 ? Direction.Column : _a, testId = props.testId, children = props.children;
    var containerClass = classNames("oui-flex", "oui-flex-" + direction, {
        "oui-child-margin-right oui-child-margin-medium": direction === Direction.Row
    });
    return (React.createElement("div", { className: containerClass, "data-test-id": testId, role: "group" }, children));
};
/**
 * Component that renders an option label in an option group
 */
exports.OptionLabel = function (_a) {
    var option = _a.option, htmlFor = _a.htmlFor, disabled = _a.disabled;
    // Mute the label text if the field is disabled.
    var className = classNames("oui-form-label oui-react-form-label", {
        "oui-text-muted": option.disabled || disabled
    });
    var labelElement = (React.createElement("label", { className: className, htmlFor: htmlFor }, option.label));
    var descriptionElement = option.description && (React.createElement("p", { className: "oui-text-small oui-margin-remove oui-text-muted oui-text-break" }, option.description));
    return (React.createElement("div", { className: "oui-display-inline-block oui-text-top oui-react-form-label" },
        labelElement,
        descriptionElement));
};
//# sourceMappingURL=OptionsGroup.js.map